export function runWhenIdle(cb, timeout = 1500) {
  if (typeof window === "undefined") return;
  const ric = window.requestIdleCallback;
  if (typeof ric === "function") {
    ric(
      () => {
        try {
          cb();
        } catch (e) {
          // ignore
        }
      },
      { timeout }
    );
    return;
  }
  setTimeout(() => {
    try {
      cb();
    } catch (e) {
      // ignore
    }
  }, 1);
}

